import { VoucherCategory, } from '@debbie/common/dist/economy/vouchers/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { search } from '@debbie/common/dist/util/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Back from '../Back.js';
import Input from '../Input.js';
import List from '../List.js';
import Loading from '../Loading.js';
const VoucherTypeSelector = (props) => {
    const allVoucherTypesLoadable = useVoucherTypes();
    const allVoucherTypes = h.hasData(allVoucherTypesLoadable)
        ? allVoucherTypesLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [category, setCategory] = useState(null);
    const [q, setQ] = useState('');
    const [indexSelect, setIndexSelect] = useState(0);
    const voucherTypes = (allVoucherTypes || [])
        .concat([])
        .filter((type) => {
        if (site === Site.Client && !type.editorSettings?.showOnCreditorWeb) {
            return false;
        }
        if (type.editorSettings.hideFromAllUsers) {
            return false;
        }
        return true;
    })
        .sort((a, b) => a.order - b.order);
    if (!allVoucherTypes) {
        return React.createElement(Loading, { width: "32px" });
    }
    const voucherTypesSearchResult = search(voucherTypes.filter((type) => {
        if (![
            VoucherCategory.COST,
            VoucherCategory.COURTCOST,
            VoucherCategory.INTEREST,
            VoucherCategory.PRINCIPAL,
            VoucherCategory.TRANSACTION,
        ].includes(type.category) || props.categoryFilter
            ? !props.categoryFilter?.includes(type.category)
            : false) {
            return false;
        }
        return true;
    }), (type) => `${lang.economyVoucherTypeLabels[type.voucherTypeId]} ${type.label} ${lang.economyCategories[type.category]}`, q, {});
    return category && site !== Site.Client ? (React.createElement(React.Fragment, null,
        React.createElement(Back, { onClick: () => {
                setCategory(null);
            }, header: lang.economyCategories[category] }),
        React.createElement(List, { items: (() => {
                const categoryVouchers = voucherTypes.filter((type) => {
                    const excludeVoucherType = (props.voucherTypeFilter || []).includes(type.voucherTypeId);
                    return type.category === category && !excludeVoucherType;
                });
                const typeMap = props.typeMap[category];
                if (typeMap != null) {
                    return typeMap(categoryVouchers).map((type) => ({
                        key: type.type.voucherTypeId,
                        label: type.label,
                        returnItem: type.type,
                    }));
                }
                return categoryVouchers
                    .sort((a, b) => {
                    // Sort by alphabetical order
                    const aLabel = lang.economyVoucherTypeLabels[a.voucherTypeId] || a.label;
                    const bLabel = lang.economyVoucherTypeLabels[b.voucherTypeId] || b.label;
                    if (aLabel < bLabel) {
                        return -1;
                    }
                    if (aLabel > bLabel) {
                        return 1;
                    }
                    return 0;
                })
                    .map((type) => ({
                    key: type.voucherTypeId,
                    label: lang.economyVoucherTypeLabels[type.voucherTypeId] || type.label,
                    returnItem: type,
                }));
            })(), onSelect: (type) => {
                props.onSelect(type);
                setTimeout(() => setCategory(null), 500);
            } }))) : (React.createElement(React.Fragment, null,
        React.createElement(Input, { placeholder: lang.inputs.search, autofocus: true, value: q, onChange: (e) => {
                setQ(e.target.value);
                setIndexSelect(0);
            }, style: {
                marginBottom: '5px',
                border: `1px solid ${THEME.COLOR_ACCENT}`,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            }, containerStyle: { margin: '-1px' }, onKeyDown: (e) => {
                switch (e.key) {
                    case 'Enter': {
                        props.onSelect(voucherTypesSearchResult[indexSelect]);
                        break;
                    }
                    case 'ArrowUp': {
                        e.preventDefault();
                        if (indexSelect > 0) {
                            setIndexSelect(indexSelect - 1);
                        }
                        else {
                            setIndexSelect(voucherTypesSearchResult.length - 1);
                        }
                        break;
                    }
                    case 'ArrowDown': {
                        e.preventDefault();
                        if (indexSelect < voucherTypesSearchResult.length - 1) {
                            setIndexSelect(indexSelect + 1);
                        }
                        else {
                            setIndexSelect(0);
                        }
                        break;
                    }
                }
            } }),
        q || site === Site.Client ? (voucherTypesSearchResult.length > 0 ? (voucherTypesSearchResult
            .sort((a, b) => {
            // Sort by alphabetical order
            const aLabel = lang.economyVoucherTypeLabels[a.voucherTypeId] || a.label;
            const bLabel = lang.economyVoucherTypeLabels[b.voucherTypeId] || b.label;
            if (aLabel < bLabel) {
                return -1;
            }
            if (aLabel > bLabel) {
                return 1;
            }
            return 0;
        })
            .map((type, index) => (React.createElement(ListItem, { onClick: () => props.onSelect(type), key: type.voucherTypeId, selected: indexSelect === index },
            lang.economyVoucherTypeLabels[type.voucherTypeId] ||
                type.label,
            React.createElement("div", null, lang.economyCategories[type.category]))))) : (React.createElement("p", { style: { margin: '1em 0.5em' } }, lang.inputs.noResults))) : (React.createElement(List, { items: Array.from(new Set(voucherTypes
                .map((type) => type.category)
                .sort((a, b) => {
                const order = (category) => {
                    return [
                        VoucherCategory.PRINCIPAL,
                        VoucherCategory.COST,
                        VoucherCategory.COURTCOST,
                        VoucherCategory.INTEREST,
                        VoucherCategory.TRANSACTION,
                    ].indexOf(category);
                };
                return order(a) - order(b);
            })
                .filter((category) => Array.isArray(props.categoryFilter)
                ? props.categoryFilter.indexOf(category) != -1
                : true)), (category) => ({
                key: category,
                label: lang.economyCategories[category],
                returnItem: category,
            })), onSelect: (category) => {
                setCategory(category);
            } }))));
};
export default VoucherTypeSelector;
const ListItem = styled.div `
  padding: 0.5em;
  cursor: pointer;
  border-bottom: 1px solid ${THEME.BORDER_STRONG};
  font-weight: normal;
  ${(props) => (props.selected ? `background: ${THEME.FILL};` : '')}

  &:hover {
    background: ${THEME.FILL};
  }

  & > div {
    font-size: 0.7em;
    margin-top: 5px;
    opacity: 0.7;
  }
`;
//# sourceMappingURL=VoucherTypeSelector.js.map